

















import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Menu1-2'
})
export default class extends Vue {}
